document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    /* Logo Resizing on Scroll */
    const navbarLogo = document.querySelector(".navbar-logo-link");

    ScrollTrigger.create({
        start: "top top",
        end: "bottom top",
        onUpdate: (self) => {
            if (self.direction === 1) {
                gsap.to(navbarLogo, {
                    height: "var(--_sizing---logo-sizing--scrolled)",
                    duration: 0.5,
                    ease: "power2.out",
                });
            } else if (self.direction === -1 && window.scrollY === 0) {
                gsap.to(navbarLogo, {
                    height: "var(--_sizing---logo-sizing--regular)",
                    duration: 0.5,
                    ease: "power2.out",
                });
            }
        },
    });

    /* Image Hover */
    document.querySelectorAll(".collection-card").forEach(card => {
        const images = card.querySelectorAll(".image.is-cover");
        let timeline;

        gsap.set(images, { opacity: 0 });
        if (images.length > 0) gsap.set(images[0], { opacity: 1 });

        card.addEventListener("mouseenter", () => {
            if (images.length > 1) {
                timeline = gsap.timeline({ repeat: -1, defaults: { duration: 0.75, ease: "power2.inOut" } });

                for (let i = 0; i < images.length; i++) {
                    let currentImg = images[i];
                    let nextImg = images[(i + 1) % images.length];

                    timeline.to(currentImg, { opacity: 0, duration: 0.75 }, `+=0.75`)
                        .to(nextImg, { opacity: 1, duration: 0.75 }, "<");
                }
            }
        });

        card.addEventListener("mouseleave", () => {
            if (timeline) {
                timeline.kill();
                gsap.to(images, { opacity: 0, duration: 0.4, ease: "power2.out" });
                gsap.to(images[0], { opacity: 1, duration: 0.4, ease: "power2.out" });
            }
        });
    });

    /* Parallax */
    document.querySelectorAll(".is-parallax").forEach((element) => {
        gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
            },
        }).fromTo(
            element,
            { scale: 1.1, y: "0" },
            { scale: 1.15, y: "10%", ease: "none" }
        );
    });

    /* Marquee */
    function startMarquee() {
        const marquee = document.querySelector(".marquee-content");
        if (!marquee) return;

        const items = Array.from(marquee.children);
        const totalWidth = items.reduce((acc, item) => acc + item.offsetWidth, 0);

        const repeatCount = 200;
        let clone = "";
        for (let i = 0; i < repeatCount; i++) {
            clone += marquee.innerHTML;
        }
        marquee.innerHTML += clone;

        const marqueeAnimation = gsap.to(marquee, {
            x: `-${totalWidth * repeatCount}px`,
            duration: 5 * repeatCount,
            ease: "linear",
            repeat: -1
        });

        document.querySelectorAll(".marquee-item").forEach(item => {
            item.addEventListener("mouseenter", () => {
                gsap.to(marqueeAnimation, { timeScale: 0, duration: 0.5, ease: "power2.out" });
            });

            item.addEventListener("mouseleave", () => {
                gsap.to(marqueeAnimation, { timeScale: 1, duration: 0.5, ease: "power2.in" });
            });
        });
    }

    startMarquee();
});